<mat-toolbar color="primary">
    <span>Rapport</span>
</mat-toolbar>
<mat-dialog-content>
    <app-report-row [item]="report"></app-report-row>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-stroked-button (click)="close()">Fermer</button>
</mat-dialog-actions>